module.exports = __webpack_public_path__ + "img/email.1f09074e.svg";